import FARE_TYPES from './fare-types';
export default function flightFareService(
    $http
) {
    'ngInject';

    let fareTypes = [];
    const FARE_TYPES_URL = '/flights/GetFareTypes';

    return {
        getFareTypes,
        getFareType,
        getCharityFareType,
        getFareTypeById,
        prepareBenefits,
    };

    function getCharityFareType() {
        return getFareTypeById(FARE_TYPES.CHARITY_TYPE);
    }

    function getFareTypeById(fareTypeId) {
        return _.find(fareTypes, {FlightFareType: fareTypeId});
    }

    function getFareType(fareTypeId) {
        return getFareTypes()
            .then(() => getFareTypeById(fareTypeId));
    }

    function getFareTypes() {
        return $http.apiGET(FARE_TYPES_URL, {noSpinner: true, cache: true})
            .then(({data}) => fareTypes = data);
    }

    function prepareBenefits(benefits) {
        const BAGGAGE_ALLOWANCE = 'BaggageAllowance';
        const TICKET_VALIDITY = 'TicketValidity';

        if (!benefits.hasOwnProperty(BAGGAGE_ALLOWANCE)) {
            benefits[BAGGAGE_ALLOWANCE] = 0;
        }

        return Object
            .entries(benefits)
            .filter(([benefit, value]) => benefit === BAGGAGE_ALLOWANCE ? true : !!value)
            .map(([benefit, value]) => {
                let count = angular.isNumber(value) ? value : '';

                if (benefit === BAGGAGE_ALLOWANCE && value > 0) {
                    count = `X${value}`;
                } else if (benefit === TICKET_VALIDITY) {
                    count = `${value}M`;
                }

                return {
                    count,
                    className: benefit.toLowerCase(),
                };
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/flights/flight-recommendation/flight-fare/flight-fare-service.js